import ActiveIncidentsBanner from '@platform-ui-common/components/ActiveIncidentsBanner/index.js';
import Navbar from '@platform-ui-common/components/Navbar/index.js';
import { ApplicationProgress } from '@platform-ui-common/components/ProgressPopper/index.js';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import useActiveIncident from '@platform-ui-common/hooks/useActiveIncident.js';
import useProgress from '@platform-ui-common/hooks/useProgress/useProgress.js';
import useViewReset from '@platform-ui-common/hooks/useViewReset.js';
import Color, { BackgroundColors, TextColors } from '@platform-ui-common/utilities/Color.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';
import { ReactNode, useEffect } from 'react';
import UserToolbar from '../UserToolbar/index.js';

interface ApplicantLayoutProps {
  children: ReactNode;
}

export default function ApplicantLayout({ children }: ApplicantLayoutProps): JSX.Element {
  const partner = usePartner();
  const { user } = useAuth();
  const { incidents } = useActiveIncident(partner?.id);
  const desktopWidthClasses = 'lg:w-4/5 lg:max-w-[96rem] lg:mx-auto';

  useViewReset();
  useEffect(() => {
    const googleTranslateWidget = document.getElementById('google_translate_element');
    if (googleTranslateWidget) googleTranslateWidget.style.display = 'block';
  }, []);

  const { progress } = useProgress();

  return (
    <div className={`w-full flex flex-col min-h-[100vh] ${TextColors[Color.Text]} relative`}>
      <Navbar partner={partner} />
      <ActiveIncidentsBanner incidents={incidents} />
      <main className="w-full flex flex-col flex-grow relative">
        <div className="w-full flex flex-col flex-grow lg:bg-grayBackground">
          <div
            className={`
            ${BackgroundColors[Color.White]} w-full relative
            ${desktopWidthClasses} lg:my-10 flex flex-grow lg:rounded-[10px] 
            lg:shadow-layout
            `}
          >
            {progress && (
              <div className="border-r border-r-solid border-tableBorder py-1 px-4 hidden lg:inline">
                <ApplicationProgress />
              </div>
            )}
            <div className="flex-grow flex flex-col py-8 px-2 lg:py-6 lg:px-4 min-w-0">
              {children}
            </div>
          </div>
        </div>
        {user?.core && <UserToolbar />}
      </main>
    </div>
  );
}
